import { configureStore } from '@reduxjs/toolkit';

import customer from '../features/admin/customerSlice';
import home from '../features/home/homeSlice';
import operator from '../features/admin/operatorSlice';
import product from '../features/admin/productSlice';
import report from '../features/admin/reportSlice';
import serialCheck from '../features/admin/serialCheckSlice';
import sku from '../features/admin/skuSlice';
import skuProducts from '../features/admin/skuProductsSlice';
import user from '../features/admin/userSlice';

const store = configureStore({
  reducer: {
    customer,
    home,
    operator,
    product,
    report,
    serialCheck,
    sku,
    skuProducts,
    user,
  },
});

export default store;
